import { Data } from 'signup-constants/signupData/Data';
import { DataOptions } from '../signup-data/signupDataOptions';
import { useRecommendedHublet } from './useRecommendedHublet';
export const useHublets = () => {
  const {
    recommendedHublet
  } = useRecommendedHublet();
  const hubletOptions = DataOptions[Data.HubletSelection].sort(hubletOption => hubletOption === recommendedHublet ? -1 : 0);
  return {
    hubletOptions,
    recommendedHublet
  };
};